export class EditCheckInModel {
    AccountNumber?: string;
    FirstName?: string;
    LastName?: string;
    DateOfBirth?: string;
    Notes?: string;
    PhoneNumber?: string;
    EmailAddress?: string;
    PreferredLanguage?: number;
    RecieveTextMessage?: boolean;
    AddedBy?: number;
    ServiceRequested?: number[];
    CustomFieldValues: any;
    UserRequested?: number;
    GroupRequested?: number;
    LocationId?: number;

}